import { TOUR_BLOCKED_MONTHS } from '../constants/tourBooking';

export function parseLocalDateString(dateStr) {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
}

export function formatLocalDateString(date) {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isWeekend(date) {
  const day = date.getDay();
  return day === 0 || day === 6;
}

/** Returns a date N business days after startDate (Mon–Fri; startDate itself is day 0). */
export function addBusinessDays(startDate, days) {
  const result = new Date(startDate);
  result.setHours(0, 0, 0, 0);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    if (!isWeekend(result)) added += 1;
  }
  return result;
}

export function getEarliestBookableDate(bufferBusinessDays, fromDate = new Date()) {
  const start = new Date(fromDate);
  start.setHours(0, 0, 0, 0);
  if (!bufferBusinessDays || bufferBusinessDays <= 0) return start;
  return addBusinessDays(start, bufferBusinessDays);
}

export function isMonthBlocked(dateStr, blockedMonths = TOUR_BLOCKED_MONTHS) {
  if (!dateStr || !blockedMonths?.length) return false;
  const [, month] = dateStr.split('-').map(Number);
  return blockedMonths.includes(month);
}

export function isDateBlocked(date, blockedMonths = TOUR_BLOCKED_MONTHS) {
  if (!date || !blockedMonths?.length) return false;
  return blockedMonths.includes(date.getMonth() + 1);
}

export function isBeforeEarliestBookable(dateStr, bufferBusinessDays, fromDate = new Date()) {
  if (!dateStr || !bufferBusinessDays) return false;
  const date = parseLocalDateString(dateStr);
  if (!date) return false;
  const earliest = getEarliestBookableDate(bufferBusinessDays, fromDate);
  return date < earliest;
}

export function isDateSelectable(date, { blockedMonths = [], minDate } = {}) {
  if (!date) return false;
  if (minDate && date < minDate) return false;
  if (isDateBlocked(date, blockedMonths)) return false;
  return true;
}
